import isEqual from 'lodash.isequal';
import differenceWith from 'lodash.differencewith';
import moment from 'moment';
import momentTz from 'moment-timezone';
import GLOBAL_STYLES from '../styles';
import { v4 as uuid } from 'uuid';
import * as CONFIG from '../config';

export const getAvailableUnits = authorizedModules => {
  let availableUnits = [];
  if(authorizedModules.includes('NAM_CNL_U1')) availableUnits.push('NAM-CNL-U1');
  if(authorizedModules.includes('NAM_CNL_U18')) availableUnits.push('NAM-CNL-U18');
  if(authorizedModules.includes('NAM_CNL_U19')) availableUnits.push('NAM-CNL-U19');
  if(authorizedModules.includes('NAM_CNL_U18A')) availableUnits.push('NAM-CNL-U18A');
  if(authorizedModules.includes('NAM_CNL_U12')) availableUnits.push('NAM-CNL-RD');
  if(authorizedModules.includes('NAM_LVG_U05')) availableUnits.push('NAM-LVG-U05');
  if(authorizedModules.includes('NAM_LVG_U55')) availableUnits.push('NAM-LVG-U55');
  if(authorizedModules.includes('NAM_LVG_U05A')) availableUnits.push('NAM-LVG-U05A');
  if(authorizedModules.includes('NAM_LVG_U12')) availableUnits.push('NAM-LVG-RD');
  if(authorizedModules.includes('NAM_SLB_U40_P01')) availableUnits.push('NAM-SLB-U40-P01');
  if(authorizedModules.includes('NAM_SLB_U40_P02')) availableUnits.push('NAM-SLB-U40-P02');
  if(authorizedModules.includes('NAM_SLB_U40_P03')) availableUnits.push('NAM-SLB-U40-P03');
  if(authorizedModules.includes('NAM_SLB_U12')) availableUnits.push('NAM-SLB-RD');
  if(authorizedModules.includes('NAM_MEX_U21')) availableUnits.push('NAM-MEX-U21');
  if(authorizedModules.includes('NAM_MEX_U17')) availableUnits.push('NAM-MEX-U17');
  if(authorizedModules.includes('NAM_MEX_U12')) availableUnits.push('NAM-MEX-RD');
  if(authorizedModules.includes('NAM_CNL_U20CWH')) availableUnits.push('NAM-CNL-U20CWH');
  if(authorizedModules.includes('NAM_SLB_U41')) availableUnits.push('NAM-SLB-U41');
  if(authorizedModules.includes('NAM_SLB_U42')) availableUnits.push('NAM-SLB-U42');
  if(authorizedModules.includes('NAM_SLB_U43')) availableUnits.push('NAM-SLB-U43');
  if(authorizedModules.includes('NCM_NCM_U70')) availableUnits.push('NCM-NCM-U70');
  return availableUnits;
};

export const getWeightUom = locator => {
  if(locator === 'NCM-NCM-U70') return 'kg';
  return 'lb';
};

export const getTimelineMaxWidth = (machineArr, pixelsPerHour) => {
  return (Math.max(...machineArr.map(machineObj =>
    machineObj.newSchedule.map(scheduleObj => scheduleObj.endTime - scheduleObj.startTime))
    .map(totalsArr => totalsArr.reduce((total, cur) => total + cur, 0))) / 3600000) * pixelsPerHour;
};

export const cmp = (a, b) => (a > b) - (a < b);

export const isArrayEqual = (x, y) => (differenceWith([x], [y], isEqual)).length === 0;

export const convertTimestampMD = timestamp => moment(timestamp).format('MM/DD h:mmA');

export const convertTimestampDate = timestamp => moment(timestamp).format('MM/DD/Y');

export const isAssemblyLocator = locator => {
  if(locator === 'NAM-CNL-U20CWH') return true;
  return false;
};

export const getHoursMinutes = epoch => {
  const hours = Math.floor(epoch / 3600000);
  const minutes = Math.floor((epoch % 3600000) / 60000);
  return `${hours > 0 ? `${hours}h ` : ''}${minutes}m`;
};

export const typeToColorMap = (chunkType, isCurrent, isSelected, unit) => {
  if(chunkType === 'DOWN') return isSelected ? GLOBAL_STYLES.CONSTANTS.lightGray : GLOBAL_STYLES.CONSTANTS.midGray;
  if(chunkType === 'STOPPAGE') return isSelected ? GLOBAL_STYLES.CONSTANTS.lightBlue : GLOBAL_STYLES.CONSTANTS.blueColor;
  if(chunkType === 'JOB') {
    if(isCurrent) return isSelected ? GLOBAL_STYLES.CONSTANTS.lightOrange : GLOBAL_STYLES.CONSTANTS.orangeColor;
    else if(unit === 'RD') return isSelected ? GLOBAL_STYLES.CONSTANTS.lightYellow : GLOBAL_STYLES.CONSTANTS.yellowColor;
    else return isSelected ? GLOBAL_STYLES.CONSTANTS.lightGreen : GLOBAL_STYLES.CONSTANTS.greenColor;
  }
};

export const getAcronym = str => str.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '');

export const getMachinePrefixFromLocator = locator => {
  if(locator === 'NAM-CNL-U1') return '01';
  if(locator === 'NAM-LVG-U05') return '05';
  if(locator === 'NAM-SLB-U40-P01') return '40';
  if(locator === 'NAM-SLB-U40-P02') return '40';
  if(locator === 'NAM-SLB-U40-P03') return '40';
  if(locator === 'NAM-SLB-U41') return '41';
  if(locator === 'NAM-SLB-U42') return '42';
  if(locator === 'NAM-SLB-U43') return '43';
  if(locator === 'NAM-MEX-U21') return '21';
  if(locator === 'NAM-MEX-U17') return '17';
  return '';
};

export const getLocatorUnit = locator => {
  if(locator.startsWith('NAM-SLB-U40')) return 'U40';
  if(locator === 'NAM-CNL-U1') return 'U01';
  return locator.split('-').pop();
};

const generatePeriods = (scheduleArr, jobs, standards, timeNow) => {
  scheduleArr = scheduleArr.filter(s => !s.isChangeover)
    .sort((a, b) => cmp(a.isCurrent ? 0 : 1, b.isCurrent ? 0 : 1) ||
      cmp(a.startTime, b.startTime))
    .map(s => {
      if(!s.staticStartTime) return s;
      return {
        ...s,
        startTime: s.staticStartTime,
        dynamicStartTime: s.staticStartTime,
        endTime: s.staticStartTime + (s.endTime - s.startTime),
      };
    });
  if(scheduleArr.length) {
    for(let i = 0; i < scheduleArr.length; i++) {
      if(!scheduleArr[i].isStoppage) {
        const jobNumbers = scheduleArr[i].jobNumbers;
        const thisJobData = jobs.find(jobArr => jobArr.some(j => jobNumbers.includes(j.jobNumber)));
        // remove schedule object if job does not exist
        if(!thisJobData) {
          scheduleArr.splice(i, 1);
          i--;
          continue;
        }
        // add in shift stoppages
        if(scheduleArr[i].shifts && thisJobData) {
          let runTime = thisJobData[0].stdTotalRunTime;
          let periods = [];
          const downShifts = scheduleArr[i].shifts.filter(o => !o.enabled).map(o => o.name);
          const startTime = momentTz.tz(scheduleArr[i].startTime, standards.timeZone);
          let nextHourStart = startTime.clone().milliseconds(0).seconds(0).minutes(0).add(1, 'hour');
          const initialShift = getShiftFromHour(startTime.hour(), standards.shiftTimes);
          periods.push({
            startTime: startTime.valueOf(),
            endTime: Math.min(nextHourStart.valueOf(), startTime.valueOf() + runTime),
            type: downShifts.includes(initialShift) ? 'DOWN' : 'RUNNING',
          });
          while(nextHourStart.valueOf() < (startTime.valueOf() + runTime)) {
            // console.log('--------------------------------------');
            // console.log('startTime:', nextHourStart.valueOf());
            // console.log('currentEndTime:', (startTime.valueOf() + runTime));
            const nextNextHourStart = nextHourStart.clone().add(1, 'hour');
            const shiftName = getShiftFromHour(nextHourStart.hour(), standards.shiftTimes);
            const periodEndTime = Math.min(nextNextHourStart.valueOf(), startTime.valueOf() + runTime);
            if(downShifts.includes(shiftName)) {
              // console.log('nextNextHourStart:', nextNextHourStart.valueOf(), nextNextHourStart.valueOf() < startTime.valueOf() + runTime);
              // console.log('endTime:', startTime.valueOf() + runTime, startTime.valueOf() + runTime < nextNextHourStart.valueOf());
              periods.push({
                startTime: nextHourStart.valueOf(),
                endTime: periodEndTime,
                type: 'DOWN',
              });
              runTime += periodEndTime - nextHourStart.valueOf();
            }
            else periods.push({
              startTime: nextHourStart.valueOf(),
              endTime: periodEndTime,
              type: 'RUNNING',
            });
            nextHourStart = nextNextHourStart;
          }
          // join adjacent down periods
          periods = periods.reduce((arr, cur) => {
            if(arr[arr.length - 1].length === 0 ||
              (arr[arr.length - 1][arr[arr.length - 1].length - 1].endTime === cur.startTime &&
                arr[arr.length - 1][arr[arr.length - 1].length - 1].type === cur.type))
              arr[arr.length - 1].push(cur);
            else arr.push([cur]);
            return arr;
          }, [[]]).map(arr => ({
            startTime: arr[0].startTime,
            endTime: arr[arr.length - 1].endTime,
            type: arr[0].type,
          }));
          scheduleArr[i].periods = periods;
          scheduleArr[i].endTime = startTime.valueOf() + runTime;
          scheduleArr = fillScheduleGaps(scheduleArr, timeNow).filter(s => !s.isChangeover);
          // console.log('thisJobData:', thisJobData);
          // console.log('downShifts:', downShifts);
          // console.log('scheduleArr[i].shifts:', scheduleArr[i].shifts);
          // console.log('runTime:', runTime);
          // console.log('periods:', periods);
        }
      }
    }
  }
  return scheduleArr;
};

const generateAdditionalStoppages = (scheduleArr, jobs) => {
  scheduleArr = scheduleArr.filter(s => !s.isChangeover)
    .sort((a, b) => cmp(a.isCurrent ? 0 : 1, b.isCurrent ? 0 : 1) ||
      cmp(a.startTime, b.startTime))
    .map(s => {
      if(!s.staticStartTime) return s;
      return {
        ...s,
        startTime: s.staticStartTime,
        dynamicStartTime: s.staticStartTime,
        endTime: s.staticStartTime + (s.endTime - s.startTime),
      };
    });
  if(scheduleArr.length > 1) {
    for(let i = 1; i < scheduleArr.length; i++) {
      if(!scheduleArr[i].isStoppage) {
        // find previous job
        const prevJob = scheduleArr.slice(0, i).reverse().find(s => !s.isStoppage);
        if(prevJob) {
          const thisJobData = jobs.find(jobArr => jobArr.some(j => scheduleArr[i].jobNumbers.includes(j.jobNumber)));
          const prevJobData = jobs.find(jobArr => jobArr.some(j => prevJob.jobNumbers.includes(j.jobNumber)));
          if(thisJobData && prevJobData) {
            // insert full mold change
            if(thisJobData[0].toolNumber !== prevJobData[0].toolNumber) {
              const moldChangeTime = CONFIG.DEFAULT_MOLD_CHANGE_TIME_MINUTES * 60000;
              const changeOverStoppage = {
                dynamicStartTime: scheduleArr[i].startTime - 1,
                endTime: scheduleArr[i].startTime - 1 + moldChangeTime,
                machineCommonName: scheduleArr[i].machineCommonName,
                machineLocator: scheduleArr[i].machineLocator,
                machineSerialNumber: scheduleArr[i].machineSerialNumber,
                schedulingId: uuid(),
                startTime: scheduleArr[i].startTime - 1,
                isStoppage: true,
                stoppageReason: 'MOLD CHANGE',
                isChangeover: true,
              };
              if(scheduleArr[i].staticStartTime) {
                changeOverStoppage.staticStartTime = scheduleArr[i].startTime - moldChangeTime;
                changeOverStoppage.dynamicStartTime = scheduleArr[i].startTime - moldChangeTime;
                changeOverStoppage.endTime = scheduleArr[i].startTime;
                changeOverStoppage.startTime = scheduleArr[i].startTime - moldChangeTime;
              }
              scheduleArr.splice(i, 0, changeOverStoppage);
              i++;
            }
            else if(JSON.stringify(thisJobData[0].partMaterials.map(m => m.materialNumber).sort()) !==
              JSON.stringify(prevJobData[0].partMaterials.map(m => m.materialNumber).sort())) {
              const colorChangeTime = CONFIG.DEFAULT_COLOR_CHANGE_TIME_MINUTES * 60000;
              const changeOverStoppage = {
                dynamicStartTime: scheduleArr[i].startTime - 1,
                endTime: scheduleArr[i].startTime - 1 + colorChangeTime,
                machineCommonName: scheduleArr[i].machineCommonName,
                machineLocator: scheduleArr[i].machineLocator,
                machineSerialNumber: scheduleArr[i].machineSerialNumber,
                schedulingId: uuid(),
                startTime: scheduleArr[i].startTime - 1,
                isStoppage: true,
                stoppageReason: 'COLOR CHANGE',
                isChangeover: true,
              };
              if(scheduleArr[i].staticStartTime) {
                changeOverStoppage.staticStartTime = scheduleArr[i].startTime - colorChangeTime;
                changeOverStoppage.dynamicStartTime = scheduleArr[i].startTime - colorChangeTime;
                changeOverStoppage.endTime = scheduleArr[i].startTime;
                changeOverStoppage.startTime = scheduleArr[i].startTime - colorChangeTime;
              }
              scheduleArr.splice(i, 0, changeOverStoppage);
              i++;
            }
            else {
              const jobChangeTime = CONFIG.DEFAULT_JOB_CHANGE_TIME_MINUTES * 60000;
              const changeOverStoppage = {
                dynamicStartTime: scheduleArr[i].startTime - 1,
                endTime: scheduleArr[i].startTime - 1 + jobChangeTime,
                machineCommonName: scheduleArr[i].machineCommonName,
                machineLocator: scheduleArr[i].machineLocator,
                machineSerialNumber: scheduleArr[i].machineSerialNumber,
                schedulingId: uuid(),
                startTime: scheduleArr[i].startTime - 1,
                isStoppage: true,
                stoppageReason: 'JOB CHANGE',
                isChangeover: true,
              };
              if(scheduleArr[i].staticStartTime) {
                changeOverStoppage.staticStartTime = scheduleArr[i].startTime - jobChangeTime;
                changeOverStoppage.dynamicStartTime = scheduleArr[i].startTime - jobChangeTime;
                changeOverStoppage.endTime = scheduleArr[i].startTime;
                changeOverStoppage.startTime = scheduleArr[i].startTime - jobChangeTime;
              }
              scheduleArr.splice(i, 0, changeOverStoppage);
              i++;
            }
          }
        }
      }
    }
  }
  return scheduleArr;
};

const fillScheduleGaps = (scheduleArr, timeNow) => {
  scheduleArr = scheduleArr.filter(s => !s.isGenerated)
    .sort((a, b) => cmp(a.isCurrent ? 0 : 1, b.isCurrent ? 0 : 1) ||
      cmp(a.startTime, b.startTime))
    .map(s => {
      if(!s.staticStartTime) return s;
      return {
        ...s,
        startTime: s.staticStartTime,
        dynamicStartTime: s.staticStartTime,
        endTime: s.staticStartTime + (s.endTime - s.startTime),
      };
    });
  let complete = scheduleArr.length === 0;
  while(!complete) {
    for(let i = 0; i < scheduleArr.length; i++) {
      if(i === 0) {
        if(scheduleArr[i].startTime < timeNow ||
          (scheduleArr[i].startTime > timeNow && !scheduleArr[i].staticStartTime)) {
          scheduleArr[i] = {
            ...scheduleArr[i],
            dynamicStartTime: timeNow,
            startTime: timeNow,
            endTime: timeNow + (scheduleArr[i].endTime - scheduleArr[i].startTime),
          };
          break;
        }
      }
      else {
        if(scheduleArr[i].startTime < scheduleArr[i - 1].endTime ||
          (scheduleArr[i].startTime > scheduleArr[i - 1].endTime && !scheduleArr[i].staticStartTime)) {
          scheduleArr[i] = {
            ...scheduleArr[i],
            dynamicStartTime: scheduleArr[i - 1].endTime,
            startTime: scheduleArr[i - 1].endTime,
            endTime: scheduleArr[i - 1].endTime + (scheduleArr[i].endTime - scheduleArr[i].startTime),
          };
          break;
        }
      }
      if(i === scheduleArr.length - 1) complete = true;
    }
  }
  return scheduleArr.map((scheduleObj, index, array) => {
    if(index === 0) {
      if(scheduleObj.startTime > timeNow) return [
        {
          dynamicStartTime: timeNow,
          endTime: scheduleObj.startTime,
          machineCommonName: scheduleObj.machineCommonName,
          machineLocator: scheduleObj.machineLocator,
          machineSerialNumber: scheduleObj.machineSerialNumber,
          schedulingId: uuid(),
          startTime: timeNow,
          isStoppage: true,
          stoppageReason: 'NO SCHEDULE',
          isGenerated: true,
        },
        scheduleObj,
      ];
      else return scheduleObj;
    }
    else {
      if(scheduleObj.startTime > array[index - 1].endTime) return [
        {
          dynamicStartTime: array[index - 1].endTime,
          machineCommonName: scheduleObj.machineCommonName,
          machineLocator: scheduleObj.machineLocator,
          machineSerialNumber: scheduleObj.machineSerialNumber,
          schedulingId: uuid(),
          startTime: array[index - 1].endTime,
          endTime: scheduleObj.startTime,
          isStoppage: true,
          stoppageReason: 'NO SCHEDULE',
          isGenerated: true,
        },
        scheduleObj,
      ];
      else return scheduleObj;
    }
  }).flat();
};

export const adjustSchedule = (scheduleArr, jobs, standards, timeNow) =>
  fillScheduleGaps(generateAdditionalStoppages(generatePeriods(scheduleArr, jobs, standards, timeNow), jobs), timeNow);

export const getShiftFromHour = (hour, shiftTimes) => {
  const shiftObj = shiftTimes.find(o => o.startHour <= hour && o.endHour > hour);
  return shiftObj ? shiftObj.shiftName : null;
};

export const rangesOverlap = (startA, endA, startB, endB) => startA <= endB && endA >= startB;

export const getShift = (now, timeZone, shiftTimes, shiftsForward = 0) => {
  const time = momentTz.tz(now, timeZone);
  const currentShift = shiftTimes.findIndex(shiftObj => time.hour() >= shiftObj.startHour && time.hour() < shiftObj.endHour);
  if(currentShift === -1) return {
    shiftName: 'UNKNOWN',
    shiftDate: time.format('Y-MM-DD'),
  };
  let dayModifier = shiftTimes[currentShift].dayModifier;
  let shiftCounter = shiftsForward;
  let shift = shiftTimes[currentShift];
  let diff = 1;
  while(shiftCounter > 0) {
    const index = (currentShift + diff) % shiftTimes.length;
    if(shift.shiftName !== shiftTimes[index].shiftName) {
      shift = shiftTimes[index];
      dayModifier = shiftTimes[currentShift].dayModifier + Math.floor((currentShift + diff) / shiftTimes.length);
      shiftCounter--;
    }
    diff++;
  }
  time.add(dayModifier, 'days');
  const shiftStart = time.clone();
  const shiftEnd = time.clone();
  const shiftParts = shiftTimes.filter(o => o.shiftName === shift.shiftName);
  const firstShiftPart = shiftParts[0];
  const lastShiftPart = shiftParts[shiftParts.length - 1];
  if(firstShiftPart.dayModifier) shiftStart.subtract(firstShiftPart.dayModifier, 'days');
  shiftStart.milliseconds(0);
  shiftStart.seconds(0);
  shiftStart.minutes(0);
  shiftStart.hours(firstShiftPart.startHour);
  if(lastShiftPart.dayModifier) shiftEnd.subtract(lastShiftPart.dayModifier, 'days');
  shiftEnd.milliseconds(0);
  shiftEnd.seconds(0);
  shiftEnd.minutes(0);
  shiftEnd.hours(lastShiftPart.endHour);
  return {
    shiftName: shift.shiftName,
    shiftDate: time.format('Y-MM-DD'),
    startTime: shiftStart.valueOf(),
    endTime: shiftEnd.valueOf(),
  };
};

export const buildGradientString = (startTime, endTime, shiftsArr, pixelsPerHour) => {
  // get shift blocks
  let start = moment(startTime);
  let numberOfBlocks = Math.ceil((endTime - startTime) / 3600000);
  let shiftBlocks = [];
  for(let i = 0; i < numberOfBlocks; i++) {
    start.add(1, 'hours');
    shiftBlocks.push(getShiftColorFromEndHour(start.hour(), shiftsArr));
  }
  
  // reduce shift blocks down to number of hours per shift and shift number
  let shiftRatios = [];
  let currentCount = 0;
  let currentColor;
  for(let i = 0; i < shiftBlocks.length; i++) {
    if(i === 0) {
      currentColor = shiftBlocks[i];
    }
    else if(shiftBlocks[i] !== currentColor) {
      shiftRatios.push([currentColor, currentCount]);
      currentCount = 0;
      currentColor = shiftBlocks[i];
    }
    currentCount++;
  }
  if(currentCount > 0) shiftRatios.push([currentColor, currentCount]);
  
  // convert shift ratios to svg params
  let x = 0;
  const rectangles = shiftRatios.map(([color, blocks]) => {
    const data = {
      color: GLOBAL_STYLES.CONSTANTS[`${color}Shift`],
      x: x,
      width: blocks * pixelsPerHour,
    };
    x += data.width;
    return data;
  });
  return {
    totalWidth: x,
    rectangles,
  };
};

const convertHour = hour => {
  if(hour === 0) return 24;
  return hour;
};

const getShiftColorFromEndHour = (hour, shiftsArr) => {
  const shiftObj = shiftsArr.find(s => convertHour(hour) > s.startHour && convertHour(hour) <= s.endHour);
  return shiftObj ? shiftObj.associatedColor : null;
};

export const getPackageVersion = () => process.env.REACT_APP_VERSION.replace(/-/g, '');

export const getThisWeekStartEnd = (timeNow, timeZone) => {
  const startTime = momentTz.tz(timeNow, timeZone).day(0).hour(22).minute(0).second(0).millisecond(0);
  const endTime = startTime.clone().day(7);
  return {
    startTime: startTime.valueOf(),
    endTime: endTime.valueOf(),
  };
};

export const getNextWeekStartEnd = (timeNow, timeZone) => {
  const startTime = momentTz.tz(timeNow, timeZone).day(7).hour(22).minute(0).second(0).millisecond(0);
  const endTime = startTime.clone().day(7);
  return {
    startTime: startTime.valueOf(),
    endTime: endTime.valueOf(),
  };
};